import React, { Dispatch, SetStateAction, useState } from 'react';

import closeSmallTokens from '@amzn/meridian-tokens/base/icon/close-small';
import editTokens from '@amzn/meridian-tokens/base/icon/edit';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';

import { DocumentRow } from 'src/components/Agreements/AgreementsTable/grid-types';
import { EditDocumentDetail } from 'src/components/Agreements/DocumentDetail/EditDocumentDetail';
import { ViewDocumentDetail } from 'src/components/Agreements/DocumentDetail/ViewDocumentDetail';

export interface IDocumentDetailBase {
    documentId: string;
    tenantId: string;
    data: DocumentRow;
    showPrefix?: boolean;
    setLoading: Dispatch<SetStateAction<boolean>>;
    setErrorMessage: Dispatch<SetStateAction<string | undefined>>;
    onClose: () => void;
}

export interface IDocumentDetail extends IDocumentDetailBase {
    setEditMode: Dispatch<SetStateAction<boolean>>;
}

export const DocumentDetail: React.FC<IDocumentDetailBase> = (props) => {
    const [isEditMode, setEditMode] = useState(false);

    const subComponentProps = { ...props, setEditMode };
    const editor = <EditDocumentDetail {...subComponentProps} />;
    const viewer = <ViewDocumentDetail {...subComponentProps} />;

    return isEditMode ? editor : viewer;
};
